import styled from 'styled-components';
import React from 'react';
import { FinancingProps } from '~/App/shared/components/ProductCard/types';
import FinancingRowItem from '~/App/shared/components/ProductCard/components/FinancingRowItem';

const Container = styled.div`
  & > *:first-child {
    margin-top: 0;
  }
`;

const Financing = ({ rows }: { rows: FinancingProps['rows'] }) => {
  return (
    <Container>
      {rows.map((row, index) => (
        <FinancingRowItem
          key={index}
          label={row.label}
          value={row.value}
          isPrice={row.isPrice}
          initialPrice={row.initialPrice}
        />
      ))}
    </Container>
  );
};

export default Financing;
